<template>
  <div>
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "ContentView",
  props: {
    // Indicates if content view should take the whole screen (usefull for big arrays for instance)
    wideScreen: {
      type: Boolean,
      default: false,
    },
  },
})
</script>

<style lang="scss">
// In order to fully display the content of the page (especially dropdowns)
.contentView {
  min-height: 600px;
}
</style>
